module.exports = __webpack_public_path__ + "img/img4.6fc88c1e.png";